'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './master-user-directory.routes';

export class MasterUserDirectoryComponent {
  constructor(User, DTOptionsBuilder, $state, Config, Auth, $http, $stateParams, $timeout) {
    'ngInject';
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.pageTitle = Config.getPageTitleByStateWithDefault($state.current.name, "Master User Directory");
    this.Auth = Auth;
    this.$timeout = $timeout;

    this.permissions = Config.getModuleConfig(Config.Modules.Profile).getPermissions();
    this.useShortAddr = Config.getModuleConfig(Config.Modules.Profile).getUseShortAddressFormat();

    this.groups = Config.getModuleConfig(Config.Modules.General).getGroups();

    this.categories = Config.getModuleConfig(Config.Modules.General).getBusinessTypes();

    this.currentFilterCat = "";

    this.searchterm = $stateParams.searchterm;

    this.dtInstance = {};
    this.dtOptions = DTOptionsBuilder.newOptions()
      .withOption('dom', 'lfrtip')
      .withOption('responsive', true)
      .withOption('pageLength', 25)
      .withOption('hasBootstrap',true)
      .withOption('order', [0, 'asc']);

    if (Auth.isLoggedInSync()) {
      this.dtOptions = DTOptionsBuilder.newOptions()
        .withOption('dom', 'lBfrtip')
        .withOption('responsive', true)
        .withOption('pageLength', 25)
        .withOption('hasBootstrap',true)
        .withOption('order', [0, 'asc'])
        .withOption('buttons',[{
          extend: 'excel',
          title: 'User Directory'
        },{
          extend: 'csv',
          title: 'User Directory'
        },{
          title: 'User Directory',
          message: 'As of ' + moment().format("MMMM Do YYYY"),
          extend: 'pdf',
          orientation: 'landscape',
          pageSize: 'LETTER'
        },'print']);
    }

    let onComplete = _ => {
      this.showData = true;

      this.categoriesDropdown = [{cat: '', name: 'All (' + this.data.length + ')'}];
      this.categories.forEach(cat => {
        let count = this.getCount(cat);
        if (count) {
          this.categoriesDropdown.push({
            cat: cat,
            name: cat + ' (' + count + ')'
          });
        }
      });

      if (this.searchterm) {
        this.$timeout(_=>{
          jQuery("table.dataTable").DataTable().search(this.searchterm).draw();
          //this.dtInstance.DataTable.search(this.searchterm).draw();
        }, 100);
      }
    };

    this.done = 0;
    this.maxDone = this.groups.length;

    this.data = [];

    this.groups.forEach(group => {

      $http({
        method: 'GET',
        url: group.url + '/api/users'
      }).then((response) => {

        let data = response.data
          .filter(user => user.active && user.role.includes("member"))
          .map(user => {

            user.group = group.name;
            user.groupUrl = group.url;

            let workPhone = user.profile.phone.find(phone => phone.type == 'Work');
            let publicCellPhone = user.profile.phone.find(phone => phone.type == 'Cell' && !phone.private);

            if (workPhone)
              user.workPhone = workPhone.number;

            if (publicCellPhone)
              user.cellPhone = publicCellPhone.number;

            return user;
          });

        this.data = this.data.concat(data);

        this.done++;

        if (this.done == this.maxDone)
          onComplete();
      }, (response) => {
        // called asynchronously if an error occurs
        // or server returns response with an error status.
        this.done++;

        if (this.done == this.maxDone)
          onComplete();
      });
    });

    /*
    User.query(users => {
      let data = users.filter(user => user.active && user.role.includes("member"));

      this.data = data.map(user => {

        let workPhone = user.profile.phone.find(phone => phone.type == 'Work');
        let publicCellPhone = user.profile.phone.find(phone => phone.type == 'Cell' && !phone.private);

        if (workPhone)
          user.workPhone = workPhone.number;

        if (publicCellPhone)
          user.cellPhone = publicCellPhone.number;

        return user;
      });
    });
     */
  }

  setFilter(cat) {
    this.currentFilterCat = cat;
    jQuery("table.dataTable").DataTable().columns(2).search(cat).draw();
  }

  getCount(cat) {
    if (!this.data)
      return 0;

    return this.data.reduce((acc, obj) => {
      return acc + (obj.businessType === cat);
    }, 0);
  }

  formatPhone(number) {
    if (!number)
      return "-";

    try {
      var f_val = number.replace(/[^0-9]/g, "");
      return f_val.slice(0,3)+"-"+f_val.slice(3,6)+"-"+f_val.slice(6);
    } catch(err) {
      return "-";
    }

  }

  formatAddress(adr) {
    if (this.useShortAddr && adr.type != 'Other') {

      return adr.street;


    } else {

      let oAdr = [];

      oAdr.push(adr.street);
      oAdr.push("<br/>");
      if (adr.street2) {
        oAdr.push(adr.street2);
        oAdr.push("<br/>");
      }
      oAdr.push(adr.city);
      oAdr.push(", ");
      oAdr.push(adr.state);
      oAdr.push(" ");
      oAdr.push(adr.zip);
      if (adr.country) {
        oAdr.push("<br/>");
        oAdr.push(adr.country);
      }

      return oAdr.join("");

    }
  }

  setDTInstance(dtInst) {

    this.dtInstance = dtInst;
  }

  hasPermission(field) {
    if (!this.permissions.hasOwnProperty(field))
      return true;

    return this.Auth.getCurrentUserSync().role.some(r => this.permissions[field].includes(r));
  }
}

export default angular.module('conduuApp.masterUserDirectory', [uiRouter])
  .config(routes)
  .component('masterUserDirectory', {
    template: require('./master-user-directory.html'),
    controller: MasterUserDirectoryComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/directories/master-user/master-user-directory.component.js